import {Component, Input} from '@angular/core';
import { DashboardNotificationService } from '../../../../shared/notification/notification.service';

@Component({
  standalone: false,
  selector: 'app-copy-element',
  templateUrl: './copy-element.component.html',
  styleUrls: ['./copy-element.component.scss']
})
export class CopyElementComponent {
  @Input()
  elementToCopy!: string;

  @Input()
  tooltipText?: string;

  @Input()
  notificationText?: string;

  constructor(private dashboardNotificationService: DashboardNotificationService) { }

  onCopy() {
    const notificationText = this.notificationText ?? 'Copied to the clipboard'
    this.dashboardNotificationService.notify(notificationText);
  }
}
